import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useDispatch } from 'react-redux';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { CommonStyledComponentProps, ShareConfigType } from '__utils/type';
import whatsapp from "images/whatsapp.svg";
import { COLOR } from 'constants/colors';
import styled from 'styled-components';
import { showSharePopupAction } from 'components/share/share.actions';


const ShareButtonCont = styled.div<CommonStyledComponentProps>`
    height: 40px;
    vertical-align: middle;
    padding: 10px 20px;
    color: ${COLOR.GREEN};
    cursor: pointer;
    border: 1px solid #00a465;
    border-radius: 4px;
    margin-right: ${(props: any) => props.isMobile ? '8px' : ''};
    text-align: center;
`;

interface ShareClickProps{
    shareConfig: ShareConfigType;
}

const ShareButton :React.FC<ShareClickProps> = ({shareConfig}: ShareClickProps) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const onShareClick = ()=>{
        dispatch(showSharePopupAction(shareConfig));
        Mixpanel.track(getEventName(`${shareConfig.mixpanelData.eventName}` ,"clicked",`${shareConfig.mixpanelData.source}`), {
          agentCode: getAgentCode(),
          user: getUserDetails()
      });
    }
    
  return (
    <ShareButtonCont isMobile={isMobile} onClick={onShareClick}>   
    {  shareConfig?.shareTitle ? shareConfig?.shareTitle : <div><img src={whatsapp} alt="whatsapp" className="mint-icon" /><span> Share</span></div>}
    </ShareButtonCont>
  )
}

export default ShareButton